import SettingsService from '../services/SettingsService';

export default {
  namespaced: true,
  state: {
    markupFactor: 1,
    discountAdjustment: 1,
    exchangeRate: 1,
    PRICE_GAP_TOLERANCE: Number(process.env.VUE_APP_PRICE_GAP_TOLERANCE || 1.0),
    isLoading: false,
    isLoaded: false,
  },
  mutations: {
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_LOADED(state, isLoaded) {
      state.isLoaded = isLoaded;
    },
    SET_SETTINGS(state, payload) {
      state.markupFactor = payload.markupFactor;
      state.discountAdjustment = payload.discountAdjustment;
      state.exchangeRate = payload.exchangeRate;
    },
  },
  actions: {
    async fetchSettings({ commit }) {
      commit('SET_LOADING', true);
      try {
        const res = await SettingsService.getPriceSettings();
        const { data } = res.data || res;
        if (data) {
          commit('SET_SETTINGS', {
            markupFactor: data.markup_factor,
            discountAdjustment: data.discount_adjustment,
            exchangeRate: parseFloat(data.usd_exchange_rate),
          });
          commit('SET_LOADED', true);
        }
      } catch (error) {
        console.error('Failed to fetch price settings: ', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
  getters: {
    markupFactor: state => state.markupFactor,
    discountAdjustment: state => state.discountAdjustment,
    exchangeRate: state => state.exchangeRate,
    PRICE_GAP_TOLERANCE: state => state.PRICE_GAP_TOLERANCE,
    isLoading: state => state.isLoading,
    isLoaded: state => state.isLoaded,
    calculateSuggestedPrice: state => (basePrice, currency = 'MXN', customExchangeRate = null) => {
      if (!basePrice || basePrice <= 0) return 0;
      let total = basePrice * state.markupFactor * state.discountAdjustment;
      if (currency === 'USD') {
        total *= (customExchangeRate || state.exchangeRate);
      }
      return Math.round((total + Number.EPSILON) * 100) / 100;
    },
  },
};
